var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Box } from "@material-ui/core";
import { SearchTrackCatalogForm, useSearchCatalogForm, } from "./search-catalog-form";
import { SearchCatalogResult, } from "./search-catalog-result";
export var SearchCatalog = React.memo(function (props) {
    var _a = useSearchCatalogForm(), term = _a.term, genres = _a.genres, onSubmit = _a.onSubmit, params = _a.params;
    return (React.createElement(Box, null,
        React.createElement(SearchTrackCatalogForm, { term: term, genres: genres, onSubmit: onSubmit }),
        React.createElement(Box, { mt: 1 },
            React.createElement(SearchCatalogResult, __assign({ params: params }, props)))));
});
